export default {"src":"/_next/static/media/pin.e8c2d66f.svg","height":71,"width":60,"blurWidth":0,"blurHeight":0};